// Employee Report Dropdown Filter :
export const GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_REQUEST = 'GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_REQUEST'; 
export const GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_SUCCESS = 'GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_SUCCESS';
export const GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_FAILURE = 'GET_EMPLOYEE_REPORT_DROPDOWN_FILTER_FAILURE'; 

// Employee Report Detailed Table :
export const GET_EMPLOYEE_REPORT_DETAILED_TABLE_REQUEST = 'GET_EMPLOYEE_REPORT_DETAILED_TABLE_REQUEST';
export const GET_EMPLOYEE_REPORT_DETAILED_TABLE_SUCCESS = 'GET_EMPLOYEE_REPORT_DETAILED_TABLE_SUCCESS';
export const GET_EMPLOYEE_REPORT_DETAILED_TABLE_FAILURE = 'GET_EMPLOYEE_REPORT_DETAILED_TABLE_FAILURE';